"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _responsive = require("../../responsive");

var _constants = require("./constants");

var _DropdownSelect = _interopRequireDefault(require("./dropdown/DropdownSelect"));

var _helpers = require("./dropdown/helpers");

var _native = require("./native");

var _propTypes = require("./propTypes");

var _utils = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["layout", "value", "defaultValue", "onChange", "options"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SelectWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? _constants.defaultProps.layout : _ref$layout,
      propValue = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      options = _ref.options,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useBreakpoints = (0, _responsive.useBreakpoints)(),
      matches = _useBreakpoints.matches;

  var useNative = (0, _utils.shouldUseNativeSelect)(layout, matches, {
    isSearchable: forwardedProps.isSearchable,
    isMulti: forwardedProps.isMulti,
    isExperimentalLayout: !!forwardedProps.experimentalLayoutProps
  });

  var _useState = (0, _react.useState)((0, _utils.getDefaultValue)({
    isMulti: forwardedProps.isMulti,
    primaryValue: propValue,
    otherValue: defaultValue
  })),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var value = (0, _utils.getDefaultValue)({
    isMulti: forwardedProps.isMulti,
    primaryValue: propValue,
    otherValue: stateValue
  });
  var handleChange = (0, _react.useCallback)(function (newValue) {
    setStateValue(newValue);
    !!onChange && onChange(newValue);
  }, [onChange]);
  var sharedProps = {
    value: value,
    onChange: handleChange
  };

  if (useNative) {
    return (0, _core.jsx)(_native.NativeSelect, (0, _extends2.default)({}, forwardedProps, sharedProps, {
      options: (0, _helpers.isOptionGroupsAvailable)(options) ? (0, _helpers.flattenGroupOptions)(options) : options,
      ref: externalRef
    }));
  } else {
    return (0, _core.jsx)(_DropdownSelect.default, (0, _extends2.default)({}, forwardedProps, sharedProps, {
      options: options,
      ref: externalRef
    }));
  }
});
var Select = (0, _stencilReactDesc.describe)(SelectWithoutDocs).description('Form element for choosing from a list of options.');
Select.propTypes = _objectSpread({}, _propTypes.selectPropTypes);
Select.defaultProps = _objectSpread({}, _constants.defaultProps);
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;